<template>
    <v-dialog
        v-model="$store.state.eleos.demurrage"
        width="900px"
        persistent
        style="background: #fff"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title> Demurrage </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="closeDmr()"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    :headers="headers"
                    :items="demurrage"
                    hide-actions
                    dense
                >
                </v-data-table>
                <v-row justify="end">
                   <v-col cols="4">
                        <v-btn color="primary" @click="confirmDmr">Please Check the Hours</v-btn>
                   </v-col>
                </v-row>
            </v-container>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
import ConfirmDialogue from './../../ConfirmDialogue.vue';
    export default {
        props:['demurrage'],
        components:{
            ConfirmDialogue,
        },
        data: function(){
            return {
                headers:[
                    { text: 'Date', value: 'Date' },
                    { text: 'ShiftDetail', value: 'ShiftDetail' },
                    { text: 'Driver', value: 'Driver' },
                    { text: 'OrderID', value: 'OrderID' },
                    { text: 'TranType', value: 'TranType' },
                    { text: 'ExeTime', value: 'ExeTime' },
                ]
            }
        },
        methods:{
            async confirmDmr() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to close this window, the demurrage records will no longer be displayed.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.saveDmr();
            }
        },
            saveDmr: async function(){
                     var parms = {
                         Data: this.demurrage,
                     }
                     axios
                     .post('demurrage-check/all',parms,{
                         headers: {
                             Authorization: 'Bearer ' + this.$store.state.token
                         }
                     })
                     .then(response => {
                        console.log(response.data);
                        this.$emit('closeDmr');
                        this.$store.state.eleos.demurrage  = false;
                     })
                     .catch(function (error) {
                         console.log(error);
                     });
            },
            closeDmr: function(){
                        this.$emit('closeDmr');
                        this.$store.state.eleos.demurrage  = false;
            }
        },
        mounted(){

        }
    }

</script>